<template>
  <div v-if="product">
    <div v-if="product.dueDateManageNotChange">
      <div class="box-toggle-switch">
        <input type="checkbox" checked="true" class="switch-input">
        <label class="switch-label switch-label-gray"></label>
        <span class="text-red">あり</span>
      </div>
      <div v-if="product.dueDateManageFlg" class="m-t-sm">
        <date-picker
          v-model="product.expirationDate"
          placeholder=""
          ref="expirationDate"
          format="YYYY/MM/DD"
          :input-attr="{class: 'expiration-date'}"
          :lang="lang"
          :not-before="todayFormatDate"
          :disabled="isDisableEdit"
          :input-class="['mx-input', (product.expirationDate) ? '' : 'bg-no-input']"
          @change="updateExpirationDate"
        />
      </div>
    </div>
    <div v-else>
      <div class="box-toggle-switch">
        <input type="checkbox" v-model="product.dueDateManageFlg" :disabled="isDisableEdit" class="switch-input" :id="`due-date-manage-${product.asin}`">
        <label @click="updateDueDateManageFlg()" :for="`due-date-manage-${product.asin}`" class="switch-label" :class="[{ 'switch-label-gray' : isDisableEdit }]"></label>
        <span :class="`${getStatusItem.class}`">{{ getStatusItem.status }}</span>
      </div>
      <div v-if="product.dueDateManageFlg" class="m-t-sm">
        <date-picker
          v-model="product.expirationDate"
          placeholder=""
          ref="expirationDate"
          format="YYYY/MM/DD"
          :input-attr="{class: 'expiration-date'}"
          :lang="lang"
          :not-before="todayFormatDate"
          :input-class="['mx-input', (product.expirationDate) ? '' : 'bg-no-input']"
          :disabled="isDisableEdit"
          @change="updateExpirationDate"
        />
      </div>
      <div v-else class="w-150 m-t-sm mx-datepicker">
        <input type="text" class="form-control" disabled>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

export default {
  components: {
    DatePicker
  },
  props: {
    product: {
      type: Object,
      default: null
    },
    isDisableEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      }
    }
  },
  computed: {
    getStatusItem () {
      let item = {
        status: 'なし',
        class: 'text-gray'
      }
      let dueDateManageFlg = this.product.dueDateManageFlg
      if (dueDateManageFlg) {
        item.status = 'あり'
        item.class = 'text-red'
      }
      return item
    },
    todayFormatDate () {
      return moment().format('YYYY/MM/DD')
    }
  },
  methods: {
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : null
    },
    updateDueDateManageFlg () {
      if (this.product.dueDateManageFlg) {
        this.product.expirationDate = null
        this.product.shippingNgPeriod = null
      }
      setTimeout(() => {
        this.$emit('updateDueDateManageFlg', this.product)
      }, 400)
    },
    updateExpirationDate () {
      this.product.expirationDate = this.formatDate(this.product.expirationDate)
      this.$emit('updateExpirationDate', this.product)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouseAcross/components/DueDateManagementItem.vue